/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/jsonParser"/>

export const tryParseJSON = (text: string) => {
    try {
        return JSON.parse(text);
    } catch (ex) {
        return null;
    }
};